import { FC, SVGProps } from 'react';

export const LockIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M15.5 4.25C12.6005 4.25 10.25 6.60051 10.25 9.5V12.25H8.7C7.3469 12.25 6.25 13.3469 6.25 14.7V25.3C6.25 26.6531 7.3469 27.75 8.7 27.75H22.3C23.6531 27.75 24.75 26.6531 24.75 25.3V14.7C24.75 13.3469 23.6531 12.25 22.3 12.25H20.75V9.5C20.75 6.60051 18.3995 4.25 15.5 4.25ZM19.25 12.25V9.5C19.25 7.42893 17.5711 5.75 15.5 5.75C13.4289 5.75 11.75 7.42893 11.75 9.5V12.25H19.25ZM8.7 13.75C8.17533 13.75 7.75 14.1753 7.75 14.7V25.3C7.75 25.8247 8.17533 26.25 8.7 26.25H22.3C22.8247 26.25 23.25 25.8247 23.25 25.3V14.7C23.25 14.1753 22.8247 13.75 22.3 13.75H8.7Z"
			fill="currentColor"
		/>
	</svg>
);
